import { useEffect } from "react";
import threeDrawer from "../functions/threeDrawer.functions.js";
import { map } from "./useMap.sideEffects.js";
import { CAMPUS_COLLECTION } from "../../../../reduxStore/actions/main.js";

/**
 * Initialisierung des 3D Gebäudes (falls vorhanden)
 */
export default function useThreeJs(props) {
  useEffect(() => {
    // todo: das hier ist erstmal deaktiviert
    if (props.mapLoaded && false) {
      threeDrawer({
        map: map,
        location: [
          CAMPUS_COLLECTION.getCurrentCampus().center.lng,
          CAMPUS_COLLECTION.getCurrentCampus().center.lat,
        ],
      });
    }
  }, [props.mapLoaded]);
}
